import * as rfdc from 'rfdc';

export type CloneFunction<T> = (value: T | undefined) => T | undefined;

export class Rfdc {
  public static default<T>(): CloneFunction<T> {
    return Rfdc.withOptions({ proto: true, circles: false });
  }

  public static withOptions<T>(options: rfdc.Options): CloneFunction<T> {
    return (rfdc as any)['default'] ? (rfdc as any)['default'](options) : rfdc(options);
  }
}
